var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlacklisted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 25 25",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 3.52174V3.52174C20.1569 3.52174 21.5 4.86488 21.5 6.52174L21.5 8.66459C21.5 8.99871 21.5 9.16578 21.4234 9.28774C21.3834 9.35135 21.3296 9.40513 21.266 9.44509C21.144 9.52173 20.977 9.52173 20.6429 9.52173L15.5 9.52173M18.5 3.52174V3.52174C16.8431 3.52174 15.5 4.86488 15.5 6.52173L15.5 9.52173M18.5 3.52174L7.5 3.52174C5.61438 3.52174 4.67157 3.52174 4.08579 4.10752C3.5 4.69331 3.5 5.63612 3.5 7.52174L3.5 21.5217L6.5 20.5217L9.5 21.5217L12.5 20.5217L15.5 21.5217L15.5 9.52173",
    stroke: "#315CD5",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.52173L11.5 7.52173",
    stroke: "#315CD5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11.5217H7.5",
    stroke: "#315CD5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.5217L10.5 15.5217",
    stroke: "#315CD5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlacklisted);
export default __webpack_public_path__ + "static/media/blacklisted.d84747ed558778edc6a7cfe426e2e96b.svg";
export { ForwardRef as ReactComponent };